<!-- <template>
    <div class="main-container">
        <div class="sub-container">
            
            <div class="invite-form">
                <h6 id="h6">Invite people to this organisation</h6>
                <div class="email-field">
                    <div style="width: 50%;">
                        <q-input filled v-model="Email" placeholder="Enter a Email" :dense="dense"
                            style="border:2px solid #027BE3 ;border-right: none;" />
                    </div>
                    <div style="width: 25%;">
                        <q-select filled v-model="user" :options="dropdowns" label="Select"
                            style="border:2px solid #027BE3 ;" />
                    </div>
                    <div style="margin-left: 20px">
                        <q-btn color="primary" label="Invite User" @click="inviteUser"  />
                        <p v-if="userRole">Email Sent!</p>
                    </div>

                </div>
                <div v-if="enteredDetailsList.length > 0" class="listedItems">
                    <ul>
                        <li v-for="(details, index) in enteredDetailsList" :key="index" class="list">
                            <div>
                                
                                <strong> {{ details.email }}</strong> <br>
                                <p style="font-size: x-small;">{{ logged_useremail }} invited {{ details.email }} at {{
                                    insert_timestamp }}</p>
                            </div>
                            <div>
                                <q-btn color="primary" style="margin-right: 5%;">{{ details.user.label }}</q-btn>
                                
                            </div>
                        </li>
                    </ul>
                </div>

            </div>



        </div>

    </div>
</template> -->
<template>
    <div class="main-container">

        <header>
            <h6>Invite User</h6>
        </header>
        <div>
            <div class="Emailfield">
                <div style="width: 30%;">
                    <q-input v-model="Email" label="Email" type="email" filled outlined dense bg-color="white"
                        style="border: 2px solid #AEBCE4;border-right: none;" />
                    <div style="color:red;text-align: center;" v-if="errorMessage">{{ errorMessage
                    }}</div>
                </div>
                <div>
                    <q-select filled v-model="user" :options="dropdowns" label="Select" dense
                        style="border:2px solid #AEBCE4 ;" />
                </div>
                <div style="margin-left: 30px;">
                    <button class="invite-button" @click="inviteUser" :disabled="isButtonDisabled">Invite User</button>
                    <div style="color:green;text-align: center;" v-if="invitationmsg">{{ invitationmsg
                    }}</div>

                </div>

            </div>
            <div class="listedItems">
                <table>
                    <thead>
                        <tr style="font-size: small;">
                            <th style="text-align: left;font-size: small;">Email</th>
                            <th style="font-size: small;text-align: center;">User Role</th>

                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(details, index) in tabledata" :key="index" class="list">
                            <td style="text-align: left;">
                                <strong>{{ details.user_email }} </strong><button class="userstatus" :style="{
                                    color:
                                        details.user_status === 'Active' ? 'green' :
                                            (details.user_status === 'Verified' ? 'green' :
                                                (details.user_status === 'Invited' ? 'orange' : 'red'))
                                }">{{ details.user_status }}</button>
                                <!-- <strong>{{ details }} {{ index }}</strong> -->
                                <p style="font-size: x-small;" v-if="details.user_role !== 'Owner'">
                                    {{ details.logged_user_email }} has invited {{ details.user_email }} at {{
                                        details.insert_timestamp }}
                                </p>
                            </td>
                            <td style="text-align:center;">
                                <p color="primary" class="button-like-element" style="margin-right: 5%;">{{
                                    details.user_role }}</p>
                            </td>
                            <!-- <td>
              <q-btn color="primary" @click="inviteUserForDetail(details)">Invite</q-btn>
            </td> -->
                        </tr>
                    </tbody>
                </table>
            </div>

        </div>


    </div>
</template>

<style >
th {
    background-color: #E7EBF0;
    font-size: medium;
    font-weight: bold;
}

td {
    background-color: #FFFFFF;

}

.main-container {
    margin-top: 20px;
    margin-left: 20px;
    margin-right: 30px;
    border-radius: 5px;
    height: auto;
}

.custom-input {
    background-color: white !important;
}

q-input.custom-input {
    background-color: white !important;
    border: 2px solid #A5BBE4 !important;
}

.quasarfield {
    height: 50px !important;

}

.Emailfield {
    display: flex;
    width: 100%;
}

.button-like-element {
    /* display: inline-block; */
    padding: 5px 5px;
    background-color: #e7edf3;
    /* Button color */
    color: black;
    /* Text color */
    border: none;
    border-radius: 4px;
    /* Prevent pointer events */
}

.userstatus {
    padding: 5px;
    border: none;
    border-radius: 30px;


}

.listedItems {

    margin-top: 3%;
}

.invite-button {
    padding: 5px;
    background-color: #2E87EE;
    color: white;
    border-radius: none;
    border: none;
    height: 2.7rem;

}

@media only screen and (max-width: 600px) {
    q-input {
        height: 2rem;
    }

    .invite-button {
        margin-top: 0.3rem;
    }

    .q-field--dense .q-field__control,
    .q-field--dense .q-field__marginal {
        height: 50px;
    }


}

/* .main-container {

    margin-top: 20px;
    margin-left: 20px;
    margin-right: 30px;
    border-radius: 5px;
    height: auto;


}

.inviteuser-head {
    margin: 10px;
    text-align: center;
}

.invitation {
    margin: 10px;
    font-size: larger;
    text-align: center;

}

.second-element {
    height: auto;
    background-color: white;
    width: 50%;
}



.invite-form>#h6 {
    text-align: center;
    color: white;
    padding: 10px;
    background-color: #378cef;
}

.email-field {
    display: flex;
    margin-top: 5%;

}

.listedItems {

    margin-top: 8%;
}

.list {
    display: flex;
    justify-content: space-between;
} */
</style>

<script>


export default {
    data() {
        return {
            api_url: this.$store.state.API_URL[process.env.VUE_APP_ENV],
            Email: '',
            user: {
                label: 'Non-Admin',
                value: 'non-admin',
            },
            invitationmsg: '',
            errorMessage: '',
            enteredDetails: null,
            dropdowns: [

                {
                    label: 'Non-Admin',
                    value: 'non-admin',
                },
                {
                    label: 'Admin',
                    value: 'admin',
                },
            ],
            enteredDetailsList: '',
            insert_timestamp: [],
            logged_useremail: '',
            userRole: '',
            tabledata: []

        }
    },
    mounted() {
        this.datasync();
        console.log('mounted', this.tabledata)
        this.startTime = new Date();
        this.beforeDestroy();

    },

    computed: {
        isButtonDisabled() {

            var regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
            if (!this.Email) {
                this.errorMessage = '';
                return true;
            }
            if (this.Email && !regex.test(this.Email)) {
                this.errorMessage = 'Please enter a valid email address.';
                return true;
            } else {
                this.errorMessage = '';
                return false;
            }
        }
    },

    methods: {
        //     trackPageDuration() {
        //   const endTime = new Date();
        //   const duration = (endTime - this.startTime) / 1000; // Convert milliseconds to seconds
        //   this.$mixpanel.track('Page View - User Settings', {
        //     page: "Invite user",
        //     duration_seconds:` User spends ${duration} seconds`
        //   });
        // },
        datasync() {
            // Show loading indicator
            this.logged_useremail = localStorage.getItem('email')
            this.$q.loading.show({
                message: 'Loading...'
            });
            this.$mixpanel.track_pageview({ "page": "Invite User" });
            //Build the URL for the HTTP POST request
            console.log('API URL:', this.api_url);
            var productURL = this.api_url + `/multiuser/user_access_list/${this.$top_level_orgid.label}`;
            // Perform the HTTP POST request
            this.$http
                .post(productURL)
                .then((response) => {
                    console.log('response call', response.data)
                    // Process the data received from the server
                    var tabular_data = response.data;
                    this.tabledata = response.data;
                    for (var i = 0; i < tabular_data.length; i++) {
                        var currentObject = tabular_data[i];
                        // Extract and store relevant data
                        this.insert_timestamp.push(currentObject.insert_timestamp);

                        console.log(this.insert_timestamp, this.logged_useremail)
                    }


                    console.log(this.tabledata)

                    this.$q.loading.hide();
                })
                .catch((err) => {
                    //Handle errors if the HTTP POST request fails
                    console.log('error call', err)
                })

        },
        inviteUser() {
            // Build the URL for the HTTP POST request
            const top_level_org_name = localStorage.getItem("top_level_org_name");
            console.log('org_name', top_level_org_name)
            const LoggedEmail = localStorage.getItem('email');
            console.log('loggedEmail', LoggedEmail)
            if (LoggedEmail === this.Email) {
                this.$alert('Please use a different email address, as this one is already logged.', 'Error', 'error')
            }
            else {
                let inviteUser = this.api_url + `/multiuser/invite_user/${top_level_org_name}/${this.user.value}/${this.Email}`;
                //Perform the HTTP POST request
                this.$http.post(inviteUser)
                    .then((response) => {
                        //Handle the successful response
                        console.log('Invite_User', response.data)
                        //Prepare new details for the list
                        var user_data = response.data;



                        if (user_data.status_code === '200') {
                            const date = new Date(); // Months are zero-based (0 for January)
                            const isoString = date.toISOString();
                            const datewithSeconds = isoString.substring(0, 19);
                            const newDetails = {
                                user_email: this.Email,
                                user_role: this.user.value,
                                insert_timestamp: datewithSeconds,
                                user_status: 'Invited',
                                logged_user_email: LoggedEmail,
                            };


                            console.log(newDetails)

                            // Add the new details to the list
                            this.tabledata.push(newDetails);
                            console.log(this.tabledata)
                            this.invitationmsg = 'Invitation Sent!'
                            setTimeout(() => {
                                this.invitationmsg = ''; // Clear the invitationmsg after 10 seconds
                            }, 10000);

                            // Optionally, reset the form or perform other actions
                            this.Email = '';
                            this.$mixpanel.track('Invited User', {

                                Action: `The User invited sucessfully!.`,
                                UserEmail: localStorage.getItem('email'),
                                Time: new Date().toISOString(),
                            })

                        }
                        else if (user_data.status_code === '401') {
                            this.$alert("You're not an Admin", 'Error', 'error');
                            this.$mixpanel.track('Error - Inviting user', {

                                Action: `The User encountered an error.`,
                                UserEmail: localStorage.getItem('email'),
                                Time: new Date().toISOString(),
                                Error: 'The system is indicating an error message stating "User is not an admin."'
                            })
                        }
                        else if (user_data.status_code === '402') {

                            this.$alert("User is already invited", 'Error', 'error');
                            this.$mixpanel.track('Error - Inviting user', {

                                Action: `The User encountered an error.`,
                                UserEmail: localStorage.getItem('email'),
                                Time: new Date().toISOString(),
                                Error: 'The system is indicating an error message stating "User is already invited!"'
                            })


                        }
                        else if (user_data.status_code === '403') {

                            this.$alert("User is part of this organisation", 'Error', 'error');
                            this.$mixpanel.track('Error - Inviting user', {

                                Action: `The User encountered an error.`,
                                UserEmail: localStorage.getItem('email'),
                                Time: new Date().toISOString(),
                                Error: 'The system is indicating an error message stating "User is part of this organisation!"'
                            })

                        }
                        else if (user_data.status_code === '406') {
                            this.$alert("User is part of diff organisation , contact admin to join this organisation", 'Error', 'error');
                            this.$mixpanel.track('Error - Inviting user', {

                                Action: `The User encountered an error.`,
                                UserEmail: localStorage.getItem('email'),
                                Time: new Date().toISOString(),
                                Error: 'The system is indicating an error message stating "User is part of diff organisation!"'
                            })


                        }



                    })
                    .catch((err) => {
                        console.log('errrr', err)
                    })
            }

        },
    }
}



</script>